export default __webpack_public_path__ + "static/media/cloud.c67449be.png";